import { buildAtendimentoIdentificacao, parseAtendimentoIdentificacao, formatAtendimentoDisplay, getAtendimentoLabels, type ModoAtendimento } from "@/lib/atendimentoMode";

export function limiteNumeroGarcom(modo: ModoAtendimento): number {
  return modo !== "mesa" ? 5 : 3;
}

export function filterNumeroGarcom(value: string, modo: ModoAtendimento): string {
  return value.replace(/\D/g, "").slice(0, limiteNumeroGarcom(modo));
}

export function normalizeNumeroGarcom(value: string, modo: ModoAtendimento): string {
  const digits = value.trim();
  if (!/^\d+$/.test(digits) || digits.length > limiteNumeroGarcom(modo)) return "";
  if (modo !== "mesa") return digits;
  const numero = Number(digits);
  return numero > 0 ? String(numero) : "";
}

export function parseIdentificacaoGarcom(value: string | null, modo: ModoAtendimento): { nome: string; numero: string; mesa?: string } {
  if (modo === "ambos") return parseAtendimentoIdentificacao(value, modo);
  const text = (value ?? "").trim();
  const match = text.match(/^(?:(?:Mesa|Comanda)\s+)?(\d+)(?:\s*-\s*(.*))?$/i);
  if (!match) return { nome: text, numero: "" };
  return { nome: (match[2] ?? "").trim(), numero: normalizeNumeroGarcom(match[1], modo) };
}

export function buildIdentificacaoGarcom(modo: ModoAtendimento, nome: string, numero: string, mesa?: string): string {
  if (modo === "ambos") return buildAtendimentoIdentificacao(modo, nome, numero, mesa);
  const nomeNormalizado = nome.trim();
  const normalized = normalizeNumeroGarcom(numero, modo);
  if (!normalized) return nomeNormalizado;
  return `${getAtendimentoLabels(modo).singular} ${normalized}${nomeNormalizado ? ` - ${nomeNormalizado}` : ""}`;
}

export function formatIdentificacaoGarcomDisplay(modo: ModoAtendimento, nome: string, numero: string): string {
  return formatAtendimentoDisplay(modo, nome, numero);
}
